// components/Navbar.js
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Menu, X, ChevronDown } from "lucide-react";
import FloatingButtons from "../Pages/FloatingButtons";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);

  const services = [
    "Web Development",
    "WordPress Development",
    "Frontend Development",
    "Backend Development",
    "E-commerce",
    "Digital Marketing",
    "Video Editing",
    "Graphic Designing",
    "Full Stack Development",
  ];

  return (
    <>
      <motion.nav
        initial={{ y: -100 }}
        animate={{ y: 0 }}
        transition={{ duration: 0.5 }}
        className="fixed w-full bg-white shadow-lg z-50"
      >
        <div className="container mx-auto px-4">
          <div className="flex justify-between items-center h-20">
            {/* Logo */}
            <motion.div
              whileHover={{ scale: 1.05 }}
              className="flex items-center space-x-2"
            >
              <div className="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-xl">R</span>
              </div>
              <div>
                <h1 className="text-2xl font-bold text-gray-800">
                  Raza Tech <span className="text-blue-600">Solutions</span>
                </h1>
              </div>
            </motion.div>

            {/* Desktop Menu */}
            <div className="hidden md:flex items-center space-x-8">
              <Link
                to="/"
                className="text-gray-700 hover:text-blue-600 font-medium transition"
              >
                Home
              </Link>

              {/* Services Dropdown */}
              <div className="relative">
                <button
                  onMouseEnter={() => setServicesOpen(true)}
                  onMouseLeave={() => setServicesOpen(false)}
                  className="flex items-center text-gray-700 hover:text-blue-600 font-medium transition"
                >
                  <Link to="/services">Services</Link>
                  <ChevronDown className="ml-1 w-4 h-4" />
                </button>

                {servicesOpen && (
                  <div
                    onMouseEnter={() => setServicesOpen(true)}
                    onMouseLeave={() => setServicesOpen(false)}
                    className="absolute top-full left-0 mt-2 w-64 bg-white rounded-lg shadow-xl py-2"
                  >
                    {services.map((service, index) => (
                      <motion.a
                        key={service}
                        initial={{ opacity: 0, x: -20 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ delay: index * 0.05 }}
                        href="#"
                        className="block px-4 py-2 text-gray-700 hover:bg-blue-50 hover:text-blue-600 transition"
                      >
                        {service}
                      </motion.a>
                    ))}
                  </div>
                )}
              </div>

              <Link
                to="/portfolio"
                className="text-gray-700 hover:text-blue-600 font-medium transition"
              >
                Portfolio
              </Link>
              <Link
                to="/about"
                className="text-gray-700 hover:text-blue-600 font-medium transition"
              >
                About
              </Link>
              <Link
                to="/contact"
                className="text-gray-700 hover:text-blue-600 font-medium transition"
              >
                Contact
              </Link>

              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="bg-blue-600 text-white px-6 py-2 rounded-lg font-medium hover:bg-blue-700 transition"
              >
                Get Quote
              </motion.button>
            </div>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="md:hidden text-gray-700"
            >
              {isOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>

          {/* Mobile Menu */}
          {isOpen && (
            <motion.div
              initial={{ opacity: 0, height: 0 }}
              animate={{ opacity: 1, height: "auto" }}
              exit={{ opacity: 0, height: 0 }}
              className="md:hidden bg-white border-t py-4"
            >
              <div className="flex flex-col space-y-4">
                <Link
                  to="/"
                  className="text-gray-700 hover:text-blue-600 font-medium py-2"
                >
                  Home
                </Link>
                <div className="space-y-2">
                  <div className="text-gray-700 font-medium py-2">
                    <Link to="/services" className="flex items-center">
                      Services
                    </Link>
                  </div>
                  <div className="pl-4 space-y-2">
                    {services.map((service) => (
                      <a
                        key={service}
                        href="#"
                        className="block text-gray-600 hover:text-blue-600 py-1"
                      >
                        {service}
                      </a>
                    ))}
                  </div>
                </div>
                <Link
                  to="/portfolio"
                  className="text-gray-700 hover:text-blue-600 font-medium py-2"
                >
                  Portfolio
                </Link>
                <Link
                  to="/about"
                  className="text-gray-700 hover:text-blue-600 font-medium py-2"
                >
                  About
                </Link>
                <Link
                  to="/contact"
                  className="text-gray-700 hover:text-blue-600 font-medium py-2"
                >
                  Contact
                </Link>
                <button className="bg-blue-600 text-white px-6 py-2 rounded-lg font-medium hover:bg-blue-700 transition mt-4">
                  Get Quote
                </button>
              </div>
            </motion.div>
          )}
        </div>
      </motion.nav>

      <FloatingButtons />
    </>
  );
};

export default Navbar;
